import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';
import './Preloader.css';

const WORDS = ['Backend', 'Async', 'LLMs', 'Production'];

export default function Preloader({ onDone }) {
  const reduce = useReducedMotion();
  const [count, setCount] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (reduce) {
      setVisible(false);
      onDone?.();
      return undefined;
    }
    const start = performance.now();
    const total = 1500;
    let raf;
    const step = (t) => {
      const p = Math.min(1, (t - start) / total);
      // ease-out so the end slows down
      const eased = 1 - Math.pow(1 - p, 3);
      setCount(Math.round(eased * 100));
      if (p < 1) raf = requestAnimationFrame(step);
      else setTimeout(() => setVisible(false), 160);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const wordIndex = Math.min(WORDS.length - 1, Math.floor((count / 100) * WORDS.length));

  return (
    <AnimatePresence onExitComplete={() => onDone?.()}>
      {visible && (
        <motion.div
          className="preloader"
          initial={{ y: 0 }}
          exit={{ y: '-100%' }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
        >
          <div className="preloader__top">
            <span className="mono">Ayaan Ahmad</span>
            <span className="mono">Dubai, UAE</span>
          </div>

          <div className="preloader__center">
            <AnimatePresence mode="wait">
              <motion.span
                key={wordIndex}
                className="preloader__word"
                initial={{ y: 18, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: -18, opacity: 0 }}
                transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
              >
                {WORDS[wordIndex]}
              </motion.span>
            </AnimatePresence>
          </div>

          <div className="preloader__bottom">
            <span className="preloader__count">{String(count).padStart(3, '0')}</span>
            <div className="preloader__bar">
              <motion.div className="preloader__fill" style={{ scaleX: count / 100 }} />
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
